export default __webpack_public_path__ + "static/media/notfound.13468768.svg";